/*=========================================================================================
  File Name: moduleAuthMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// import axios from "../../http/axios/index.js"
import axios from "../../axios.js"
import { GET_USER_INFO, CHECK_OTP, GET_CONFIG, ID_DOMAIN, MERCURE_DATA, GET_USER_SIGNIN_INFO } from "./moduleAuthTypes"

export default {
  SET_BEARER(state, accessToken) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + accessToken
    axios.defaults.headers['Authorization'] = 'Bearer ' + accessToken
    axios.defaults.headers['G-ClientID'] = localStorage.getItem("domainId")
    axios.defaults.baseURL = localStorage.getItem("endpoint")
  },
  auth_request(state) {
    state.status = 'loading'
  },
  auth_success(state, token, user) {
    state.status = 'success'
    state.token = token
    state.user = user
  },
  auth_error(state) {
    state.status = 'error'
  },
  logout(state) {
    state.status = ''
    state.token = ''
  },
  save_token(state, token) {
    state.token = token;
  },
  [GET_USER_INFO](state, data) {
    state.userInfo = data;
  },
  [GET_CONFIG](state, data) {
    // if (data.pos_feature == undefined){
    //   data.pos_feature = 0;
    // }
    state.config = data;
  },
  login(state, data) {
    state.info = data;
  },
  [CHECK_OTP](state, data) {
    state.checkOtp = data;
  },
  [ID_DOMAIN](state, data) {
    state.idDomain = data;
  },
  [MERCURE_DATA](state, data) {
    state.mercure = data;
  },
  [GET_USER_SIGNIN_INFO](state, data) {
    state.userSigninInfo = data;
  },
}
